<main id="main-content" class="main-content">
  <h2 class="form-header">5. Recommended Treatment Narratives</h2>

  @for (forest of forests; track forest; let i = $index) {
    <div class="forest-container">
      <h2 class="forest-title">{{ forest.forest_name }}</h2>
      <h3 class="treatment-title">Treatments <span class="thin"><i>(Source: GIS):</i></span> {{ countGISTreatments(i)
    }} | New Treatments: {{ countNewTreatments(i) }} | Total Treatments: {{ treatments[i].length }}</h3>
    <mat-accordion [multi]="true" #accordion="matAccordion">
      @for (treatment of treatments[i]; track treatment; let j = $index) {
        <mat-expansion-panel class="treatment-container" [expanded]="true" hideToggle
          (opened)="treatment.open = true"
          (closed)="treatment.open = false" (click)="onTreatmentClick($event, accordion)"
          (onkeypress)="onTreatmentKeypress($event, accordion)" onkeypress="">
          <mat-expansion-panel-header>
            <mat-panel-title class="treatment-title">
              @if (treatment.open) {
                <i class="material-icons green-arrow">keyboard_arrow_down</i>
              }
              @if (!treatment.open) {
                <i class="material-icons green-arrow">chevron_right</i>
              }
              <div class="treatment-title-info">
                <div>{{ j+1 }}. {{ forest.forest_name }}</div>
                <span class="thin">
                  {{treatment.option?.treatment_option}}
                  ({{treatment.option?.unit_of_measure}})
                  (Spec.{{treatment.specs[0].specification_number}})
                </span>
              </div>
              @if (treatment.new) {
                <mat-chip class="mat-chip-new">
                  NEW
                </mat-chip>
              }
            </mat-panel-title>
          </mat-expansion-panel-header>
          @for (spec of treatment.specs; track spec) {
            <div>
              <div class="text-div">
                <b>Treatment Narrative</b>
                <br>
                  <div class="text" [innerHTML]="customATOB(spec.treatment_narrative || '--')"></div>
                </div>
                @if (spec.specification_sheet) {
                  <div class="row" style="margin-left: 18px;"><a [href]="decodeURI(spec.specification_sheet)"
                    target="_blank">Spec. Sheet <fa-icon class="fa-sm" [icon]="faExternalLink"></fa-icon></a>
                  </div>
                }
              </div>
            }
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  }
</main>